T.EasyAccess = Class(
	/**
	 * @lends {T.EasyAccess#}
	 */
	{
		__construct(type) {
			let iosURL = 'https://apps.apple.com/us/app/roadgames-app/id1456577716';
			let androidURL = 'https://play.google.com/store/apps/details?id=com.roadgames&hl=' + D.LANG;

			if (type === 'home') {
				iosURL = 'https://apps.apple.com/us/app/roadgames-home/id1540565890';
				androidURL = 'https://play.google.com/store/apps/details?id=com.roadgames.virtual&hl=' + D.LANG;
			}
			this.node = mkE({
				tag: 'div',
				className: 'easy-access-main',
				els: [
					{
						tag: 'div',
						className: 'easy-access-content',
						els: [
							{
								tag: 'div',
								className: 'container',
								id: 'easy-access',
								els: [
									{
										tag: 'h2',
										text: D.Lang.get('easy-access.title')
									},
									{
										tag: 'div',
										className: 'bs-row',
										els: [
											{
												tag: 'div',
												className: 'col-0 col-md-1',
												els: [
													{
														tag: 'a',
														href: D.url('/get-app'),
														className: 'qr-image',
														els: [
															{
																tag: 'img',
																width: 116,
																height: 116,
																src: '/assets/images/qr.svg?v=2'
															}
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'col-12 col-md-3',
												els: [
													{
														tag: 'div',
														className: 'easy-access-item easy-access-item-1',
														els: [
															{
																tag: 'div',
																className: 'easy-access-item-background'
															},
															{
																tag: 'div',
																className: 'easy-access-item-content',
																els: [
																	{tag: 'h3', className: 'h4', text: D.Lang.get('easy-access.steps.0')},
																	{
																		tag: 'div',
																		className: 'store-buttons lang-' + D.LANG,
																		els: [
																			{
																				tag: 'a',
																				className: 'appstore',
																				href: iosURL
																			},
																			{
																				tag: 'a',
																				className: 'play-store',
																				href: androidURL
																			}
																		]
																	}
																]
															}
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'col-12 col-md-3',
												els: [
													{
														tag: 'div',
														className: 'easy-access-item easy-access-item-2',
														els: [
															{
																tag: 'div',
																className: 'easy-access-item-background'
															},
															{
																tag: 'div',
																className: 'easy-access-item-content',
																els: [
																	{
																		tag: 'h3', className: 'h4', text: D.Lang.get('easy-access.steps.1')}
																]
															}
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'col-12 col-md-3',
												els: [
													{
														tag: 'div',
														className: 'easy-access-item easy-access-item-3',
														els: [
															{
																tag: 'div',
																className: 'easy-access-item-background'
															},
															{
																tag: 'div',
																className: 'easy-access-item-content',
																els: [
																	{tag: 'h3', className: 'h4', text: D.Lang.get('easy-access.steps.2')}
																]
															}
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				]
			});
		}
	},
	mkE.Base
)